<template>
	<div class="componentSty">
		<m-title :titlelist="listitem"></m-title>
		<div class="componentSty_content">
			<div class="componentSty_content_title_flex">
				<div class="componentSty_content_title">
					<span class="fonints">企业简称</span>
					<el-input placeholder="请输入关键词" v-model="conditions.shortname" clearable>
					</el-input>
					<span class="fonints">企业名称</span>
					<el-input placeholder="请输入关键词" v-model="conditions.name" clearable>
					</el-input>
					<span class="fonints">企业类型</span>
					<div class="select_box">
						<m-select :list="selectastrict" v-model="selectinfo" isObj @input="chanval"></m-select>
					</div>

				</div>
				<div class="componentSty_content_title_flex_button"><button class="buttons" @click="selectlist">查询</button>
					<button class="buttons" style="color: #17B6A1;background-color: #F3F4F5;" @click="clearlist">重置</button>
				</div>
			</div>


			<div class="componentSty_content_table" style="border:none">
				<el-table :data="arrlist.list" border height="80%" style="width: 100%; height: 80%" :row-class-name="tableRowClassName" @cell-click="getchedui" :cell-style="cellStyle">

					<el-table-column show-overflow-tooltip :render-header="renderHeader" label="序号" type="index" width="50px"></el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="corptype" label="企业类型">
						<template v-slot="res">
							{{ res.row.corptype ? corptype[res.row.corptype] : "" }}
						</template>
					</el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="shortname" label="企业简称">
					</el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="name" label="企业名称">
					</el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="telephone" label="联系电话">
					</el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="address" label="地址">
					</el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" prop="totalCarCount" label="车数">
					</el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" label="状态">
						<template v-slot="res">
							<span v-if="res.row.fleetStatus == 0" class="el_spanfontstyle" style="color: #fe5a24">待审核</span>
							<span v-if="res.row.fleetStatus == 1" class="el_spanfontstyle" style="color: #13d168">正常</span>
							<span v-if="res.row.fleetStatus == 2" class="el_spanfontstyle"
								style="color: #fe5a24">审核未通过</span>
							<span v-if="res.row.fleetStatus == 3" class="el_spanfontstyle" style="color: #fe5a24">停用</span>
						</template>
					</el-table-column>
					<el-table-column show-overflow-tooltip :render-header="renderHeader" label="操作">
						<template v-slot="res">
							<el-tooltip content="停用" effect="light">
							<span v-if="res.row.fleetStatus == 3" class="iconfont icon-jinyong"
								@click="checkState(res.row)"></span>
							</el-tooltip>
								<el-tooltip content="启用" effect="light">
							<span v-if="res.row.fleetStatus == 1" class="iconfont icon-qiyong"
								@click="checkState(res.row)"></span>
							</el-tooltip>
								<el-tooltip :content="usergt.username=='system'?'编辑':'查看'" effect="light">
							<span class="iconfont icon-xiugai" @click="itemparticulars(res.row)"></span></el-tooltip>
							<el-tooltip content="推送" effect="light">
							<i class="el-icon-s-promotion" @click="pushtoproCarInfo(res.row)"></i></el-tooltip>
						</template>
					</el-table-column>
				</el-table>
				<div class="msgstatistics">
					<span style="margin-right: 20px">企业合计:{{ arrlist.totalCount }}个</span>
				</div>
				<div class="paginations" v-show="arrlist.list && arrlist.list.length">
					<el-pagination :page-size="conditions.limit" layout="total,prev, pager,next, jumper"
						:total="arrlist.totalCount" :current-page="conditions.page" @current-change="getarrlist">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import mTitle from '@/components/mTitle';
import mSelect from "@/components/mSelect";
import {
	antiShake
} from '@/plugins/other.js';
import {
	mapMutations,
	mapState,
	mapGetters
} from 'vuex';
export default {
	data() {
		return {
			listitem: [{
				name: '代理管理'
			}, {
				name: '企业列表'
			}],
			corptype: ["", "车队", "货代"],
			conditions: {
				
			},
			timeout: null,
			arrlist: {},
			selectinfo: "车队",
			selectastrict: [
				{
					status: null,
					val: "全部",
				},
				{
					status: 1,
					val: "车队",
				},
				{
					status: 2,
					val: "货代",
				},
			],
			username:''
		};
	},
	computed: {
		...mapState(['conditionsList']),
		...mapGetters(["usergt"])
	},
	components: {
		mTitle,
		mSelect
	},
	created() {
		
		console.log(this.usergt.username);
		this.conditionsList[this.$route.path] ||
			this.createConditions({
				key: this.$route.path,
				val: {
					page: 1,
					limit: 20,
					sidx: 'fleet_status', //排序字段
					order: 'asc',
					corptype:1
				},
			});
		this.conditions = this.conditionsList[this.$route.path] || {
			page: 1,
			limit: 20,
			sidx: 'fleet_status', //排序字段
			order: 'asc',
			corptype:1
		};
		if(this.$route.query.obj){
			this.selectinfo="车队"
			this.conditions.corptype=JSON.parse(this.$route.query.obj).corptype
		}
		this.getarrlist();

	},
	methods: {
		...mapMutations(['createConditions']),
		tableRowClassName({row, rowIndex}) {
			if (row.isProtocol==='1') { 
				return 'highlight-row';
			}
			return '';
		},
		getchedui(row, column, cell, event) {
            if (column.label === "车数") {
				let obj={
					shortname:row.shortname,
					useStatus:1
				}
                this.$router.push({ name: "memberlist", query: {obj: JSON.stringify(obj) } })
            }
        },
        cellStyle({ row, column, rowIndex, columnIndex }) {

            if (column.label === "车数") {
                return "font-weight:700;color:#FF6100;cursor: pointer;";
            }
            return "";
        },
		//推送企业
		pushtoproCarInfo(row){
			this.$messageBox.confirm('是否推送该企业?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async ()=>{
					const res = await this.$http(
						'api1',
						'fleet/fleetfleetmessage/pushFleetMessageToProd',
						'get',
						{ id: row.id })
					if (res.data.code !== 0) {
						this.$message.error(res.data.msg);
						throw res.data;
					}
					this.$message({
						type: 'success',
						message: '推送成功'
					});
					this.getarrlist()
		}).catch(() => {
					this.$message({
						type: 'info',
						message: '推送失败'
					});
				});
		
      },
		async getarrlist(num) {
			typeof num === 'number' && (this.conditions.page = num);
			const {
				data
			} = await this.$http(
				'api1',
				'/fleet/fleetfleetmessage/portFleetList',
				'get',
				this.conditions
			);
			if (!data) return this.$message.error('获取数据失败');
			this.arrlist = data.data;
		},
		itemparticulars(res) {
			window.sessionStorage.setItem('infoid', res.id);
			this.$router.push({
				name: 'particulars'
			});
		},
		async checkState(row) {
			if (row.fleetStatus == 3) {
				row.fleetStatus = 1;
				const {
					data
				} = await this.$http(
					'api1',
					'/fleet/fleetfleetmessage/fleetInitiateMode',
					'post', {
					ids: [row.id]
				}
				);
				if (!data || data.msg != 'success')
					return this.$message.error('修改失败');
				this.$message.success('启用成功');
			} else {
				row.fleetStatus = 3;
				const {
					data
				} = await this.$http(
					'api1',
					'/fleet/fleetfleetmessage/fleetDeadStatus',
					'post', {
					ids: [row.id]
				}
				);
				if (!data || data.msg != 'success')
					return this.$message.error('修改失败');
				this.$message.success('停用成功');
			}
		},
		selectlist() {
			antiShake((_) => {
				this.conditions.page = 1;
				this.getarrlist();
			});
		},
		//重置
		clearlist() {
			this.conditions.shortname = ""
			this.conditions.name = ""
			this.getarrlist();
		},
		chanval(e){
			this.conditions.corptype=e.status;
			this.selectinfo=e.val
		},
	},
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>
<style lang="scss">
.highlight-row {
	
	  background-color:#ffe8d6 !important;
    }
</style>